(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@wallaby-ui/layout", [], factory);
	else if(typeof exports === 'object')
		exports["@wallaby-ui/layout"] = factory();
	else
		root["@wallaby-ui/layout"] = factory();
})(self, () => {
return 